import { backgroundTransitionOnClick, IconFont, pointer, singleTextEllipsis } from '@byecode/ui'
import styled from 'styled-components'

export const Container = styled.form`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
`

export const Content = styled.div`
    width: 100%;
    padding: 0 40px 16px;
    font-size: var(--font-size-normal);
`

export const Title = styled.div`
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    color: var(--color-black);
    margin-bottom: 20px;
`

export const Item = styled.div`
    width: 100%;
    margin-top: 20px;

    > *:nth-child(2) {
        margin-top: 8px;
    }
`

export const Text = styled.span<{ size?: number; color?: string; isOmit?: boolean }>`
    font-family: 'PingFang SC';
    color: ${({ color }) => color ?? 'var(--color-black)'};
    font-size: ${({ size }) => size ?? '14'}px;
    line-height: ${({ size }) => size ?? 14 + 2}px;
    ${({ isOmit }) => isOmit && singleTextEllipsis};
    margin-bottom: 12px;
    display: block;
`

export const Footer = styled.div`
    padding: 0 20px;
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    height: 72px;
    width: 100%;
    align-items: center;
    background: var(--color-gray-50);
    border-radius: 0px 0px inherit inherit;
    gap: 12px;
`

export const SwitchWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`

export const SwitchText = styled.div`
    color: var(--color-gray-400);
    font-size: 12px;
`
